export const GPT_35_TURBO = "gpt-3.5-turbo" as const;
export const GPT_4 = "gpt-4" as const;
export const GPT_MODEL_NAMES = [GPT_35_TURBO, GPT_4];

export const DEFAULT_MAX_LOOPS_FREE = 8 as const;
export const DEFAULT_MAX_LOOPS_PAID = 16 as const;
export const DEFAULT_MAX_LOOPS_CUSTOM_API_KEY = 50 as const;
export const DEFAULT_MAX_TOKENS = 4000 as const;
export const DEFAULT_TEMPERATURE = 0.9 as const;
